import cn from 'clsx'

import { Button, CheckmarkCircleIcon, IconButton, PlusCircleIcon } from '@ds/components'

import type { TLikeButtonProps } from './LikeButton.types'
import styles from './LikeButton.module.css'

// Checkmark when liked, plus when not (parity with audio-web).
export const LikeButton = ({
    isLiked,
    label,
    disabled = false,
    variant = 'outline',
    as = 'icon',
    count = 0,
    countLabel,
    onClick,
}: TLikeButtonProps) => {
    const Icon = isLiked ? CheckmarkCircleIcon : PlusCircleIcon
    const countSlot = count > 0 ? (countLabel ?? String(count)) : null

    if (as === 'plain') {
        return (
            <button
                type="button"
                className={styles.plain}
                aria-label={label}
                data-test="like-button"
                data-test-liked={String(isLiked)}
                disabled={disabled}
                onClick={onClick}
            >
                {countSlot}
                <Icon className={styles.plainIcon} />
            </button>
        )
    }

    if (as === 'button') {
        return (
            <Button
                variant="secondary"
                size="medium"
                LeftIcon={Icon}
                className={cn({ [styles.liked]: isLiked })}
                aria-label={label}
                data-test="like-button"
                data-test-liked={String(isLiked)}
                disabled={disabled}
                onClick={onClick}
            >
                {countSlot}
            </Button>
        )
    }

    return (
        <IconButton
            variant={variant}
            size={countSlot ? 'labeled' : 'icon'}
            Icon={Icon}
            className={cn({ [styles.liked]: isLiked })}
            aria-label={label}
            data-test="like-button"
            data-test-liked={String(isLiked)}
            disabled={disabled}
            onClick={onClick}
        >
            {countSlot}
        </IconButton>
    )
}
